import React from 'react'
import cloneDeep from 'lodash/cloneDeep'
import validUrl from 'valid-url'
import { conformToMask } from 'text-mask-core'

export function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    const _URL = window.URL || window.webkitURL
    if (!file) {
      return reject({})
    }

    let image = new Image()
    image.onload = function() {
      resolve({
        width: this.width,
        height: this.height,
      })
    }
    image.src = _URL.createObjectURL(file)
  })
}

export function isValidImageSize({ width, height }) {
  return width > 600 && height > 300
}

export function isValidUri(suspect) {
  const suspectWithoutWWW = suspect.split('www.').join('')

  return (
    typeof validUrl.isWebUri(suspect) !== 'undefined' &&
    suspect[suspect.length - 1] !== '.' &&
    suspectWithoutWWW.includes('.')
  )
}

export function titleize(words) {
  return words
    .split(' ')
    .map(word => {
      return word
        .split('')
        .map((char, i) => {
          if (i === 0) {
            return char.toUpperCase()
          }
          return char
        })
        .join('')
    })
    .join(' ')
}

const US_ZIPCODE = [/\d/, /\d/, /\d/, /\d/, /\d/]

const TEXT_MASK_CONFIG = {
  guide: false,
}

export const formatZip = value => {
  return conformToMask(value, US_ZIPCODE, TEXT_MASK_CONFIG).conformedValue
}

export const formatTimestamp = (date, time) => {
  const dateTime = Date.parse(date)
  const [hours, minutes] = time.split(':').map(Number)
  return dateTime + hours * 60 * 60 * 1000 + minutes * 60 * 1000
}

export const validateTimeRange = (startTime, endTime) => {
  const [endHours, endMinutes] = endTime.split(':').map(Number)
  const [startHours, startMinutes] = startTime.split(':').map(Number)

  if (endHours < startHours) {
    return false
  } else if (endHours === startHours) {
    return startMinutes < endMinutes
  } else {
    return true
  }
}

export const getTimezoneOffset = (timestamp = Date.now()) => {
  const localDatetime = new Date(timestamp)
  const timezoneOffset = (-1 * localDatetime.getTimezoneOffset()) / 60
  if (timezoneOffset >= -4 || timezoneOffset <= -7) {
    return timezoneOffset
  } else {
    return -7
  }
}

export const splitAndDedup = (userIds, separator = ',') =>
  userIds
    .split(separator)
    .filter((userId, i, userIds) => !userIds.slice(i + 1).includes(userId))
    .map((userId, i) => (
      <div key={i} className="userId">
        {userId}
      </div>
    ))

export const sortItems = (items, field, reverse = false) => {
  const itemsClone = cloneDeep(items)

  if (!field) {
    return itemsClone
  }

  if (typeof items[0][field] === 'boolean') {
    return reverse
      ? itemsClone.sort((a, b) => b[field] < a[field])
      : itemsClone.sort((a, b) => a[field] < b[field])
  }

  return reverse
    ? itemsClone.sort((a, b) => b[field].localeCompare(a[field]))
    : itemsClone.sort((a, b) => a[field].localeCompare(b[field]))
}

export const testUrl = text =>
  // eslint-disable-next-line no-useless-escape
  /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/.test(
    text,
  )
